"use strict";

// Imports.
import * as yup from "yup";

// Export some predefined validation rules from yup.
export const emailRules = yup.string().required().email();
export const passwordRules = yup.string().required().min(8);
